

   <div class="tooltip-content" >
    <div class="tooltip-header">
      
  <button (click)="downloadTrendReport(data.employees)" class="mr-10 Download fs-16 font_semibold">
    <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
  </button>

      <div class="close_bg cp" [mat-dialog-close]>
        <img src="././assets/icon/close_icon.png" class="closeHeight">
      </div>
    </div>
    <div class="tooltip-scroll">
      <table class="custom-table">
        <thead>
          <tr>
            <th>Employee Name</th>
            <th>Department</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of data.employees">
            <td>{{ emp.employeeName }}</td>
            <td>
              <span class="dept-style" [style.color]="emp.departmentColor">
                {{ emp.department }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  


  
    
 